import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/features/promos/PromosPage.jsx");
